define('SageDotCom/Components/Videos/BrightcoveVideo',[
    "jquery",
    "eventManager",
    "SageDotCom/DataLayer/Global/brightcove-video-tracker"
],
    function ($, eventManager, tracker) {
        function BrightcoveVideo(scope) {

            // this file can be deleted once all current brightcove videos are moved to use the score version as this file is used for Iframe brightcove videos only
            
            if (window.brightcoveTrackerTimeout) {
                clearTimeout(window.brightcoveTrackerTimeout);
            }
            window.brightcoveTrackerTimeout = setTimeout(tracker.start, 250);   //Allow for iFrame to render

            eventManager.subscribe("brightcoveVideoMessageRecieved", function (eventData) {
                videoStateChange(eventData);
            });

            function videoStateChange(eventDetails) {
                if (!eventDetails || !eventDetails.message || !eventDetails.playerInfo) {
                    return;
                }

                var playerDetails = eventDetails.playerInfo;
                var videoIdFromMessage = playerDetails.videoId;
                var videoStateFromMessage;

                // event for a different video so do nothing
                if (videoId !== videoIdFromMessage) {
                    return;
                }

                // only concered with play/pause/end events
                if (playerDetails.eventType === "play") {
                    videoStateFromMessage = "playing";
                }
                else if (playerDetails.eventType === "pause" || playerDetails.eventType === "ended") {
                    videoStateFromMessage = "paused";
                }

                // video state has changed so handle this
                if (videoStateFromMessage !== null && videoStateFromMessage !== videoState) {
                    videoState = videoStateFromMessage;
                    handleStateChange(videoState);
                }
            }

            function handleStateChange(newState) {
                if (newState === "playing") {
                    // pause carousel while video is playing
                    $carousel.carousel("pause");

                }
                else if (newState === "paused") {
                    // start carousel playing again
                    // re-enable swiping on the carousel
                    if ($iframeOverlay != null && $iframeOverlay.length > 0) {
                        $iframeOverlay.fadeIn();
                    }
                    $carousel.carousel("cycle");

                }
            }

            function pauseThisVideo() {
                var brightCoveIframe = $brightcoveVideo.get(0).contentWindow;
                if (brightCoveIframe) {
                    brightCoveIframe.postMessage(
                        "pauseVideo", $brightcoveVideo.get(0).src
                    );
                    videoState = "paused";
                }
                if ($iframeOverlay != null && $iframeOverlay.length > 0) {
                    $iframeOverlay.fadeIn();
                }
            }

            function playThisVideo() {
                var brightCoveIframe = $brightcoveVideo.get(0).contentWindow;
                if (brightCoveIframe) {
                    brightCoveIframe.postMessage(
                        "playVideo", $brightcoveVideo.get(0).src
                    );
                    videoState = "paused";
                }
            }

            var $brightcoveVideo = $(scope);
            var src = $brightcoveVideo.attr("src");
            if (typeof src === "undefined" || src.indexOf("?videoId=") === -1) {
                //Brightcove won't work as there is no valid src to use
                return;
            }

            var videoId = $brightcoveVideo.attr("src").split("?videoId=").pop();
            var videoState = "paused";

            // set application id
            var brightcoveApplicationId = "SageDotCom_" + $("html").attr("locale").split("_")[0] + "_" + $("html").attr("id");
            $brightcoveVideo.attr('src', $($brightcoveVideo).attr('src') + '&applicationId=' + brightcoveApplicationId)
            
            var $carousel = $brightcoveVideo.parents(".carousel");
            var $carouselControls = $carousel.children(".carousel-control");
            var $carouselDots = $carousel.children(".carousel-indicators").children("li");
            var $iframeOverlay;

            // add iframe overlay to allow swiping in carousel
            if ($carousel.length > 0) {
                $iframeOverlay = $('<div class="brightcove-iframe-overlay"></div>').insertBefore($brightcoveVideo);
                $brightcoveVideo.attr("allow", "encrypted-media; autoplay;");
                $brightcoveVideo.attr("src", $($brightcoveVideo).attr('src') + "&muted=1");
            }

            setTimeout(function () {
                var touchStartX = 0;
                var touchEndX = 0;

                if ($iframeOverlay != null && $iframeOverlay.length > 0) {
                    $iframeOverlay[0].addEventListener('pointerdown', function (event) {
                        touchStartX = event.screenX;
                    }, false);

                    $iframeOverlay[0].addEventListener('pointerup', function (event) {
                        touchEndX = event.screenX;
                        var distX = touchEndX - touchStartX;
                        if (distX === 0) {
                            // click
                            $iframeOverlay.fadeOut("fast");
                            playThisVideo();
                        }
                        else {
                            // swipe, direction does not matter
                            if (videoState !== "paused") {
                                pauseThisVideo();
                            }
                        }
                        // reset for next event
                        touchStartX = 0;
                        touchEndX = 0;
                    }, false); 
                }

                $carouselControls.add($carouselDots).on("click", function (e) {
                    if (videoState !== "paused") {
                        pauseThisVideo();
                    }
                    
                });
                $carouselControls.add($carouselDots).on("keyup", function (e) {
                    if (e.keyCode === 13) {
                        if (videoState !== "paused") {
                            pauseThisVideo();
                        }
                    }
                });

            }, 500);
        }

        BrightcoveVideo.init = function (scope) {
            return new BrightcoveVideo(scope);
        };

        return BrightcoveVideo;

    });
